export default "__VITE_ASSET__488bbd63__"